import type { AnchorHTMLAttributes, ReactNode } from "react";
import { Link as RouterLink } from "react-router-dom";

type LinkProps = Omit<AnchorHTMLAttributes<HTMLAnchorElement>, "href"> & {
  href: string;
  children: ReactNode;
};

export function Link({ href, children, ...props }: LinkProps) {
  const external = /^(?:[a-z]+:)?\/\//i.test(href) || href.startsWith("mailto:");

  if (external) {
    return <a href={href} {...props}>{children}</a>;
  }

  return <RouterLink to={href} {...props}>{children}</RouterLink>;
}
